import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svgIcon-crop",
  "use": "svgIcon-crop-usage",
  "viewBox": "0 0 533.333 533.333",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 533.333 533.333\" id=\"svgIcon-crop\"><path d=\"m433 133l100-100-33-33-100 100h-233v-100h-67v100h-100v67h100v267h267v100h67v-100h100v-67h-100v-233m-267 33h167l-167 167v-167m33 200l167-167v167h-167\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol